import { ALL_CURRENCIES, CurrencyCodes } from '@monetize/types/common';
import { MFlex, MText } from '../../components/Monetize';
import { MCustomSelect } from '../../components/Monetize/MCustomSelect/MCustomSelect';
import { useDashboardCurrencyFilter } from './components/useDashboardCurrencyFilter';

export const DashboardCurrencyFilter = () => {
  const { currency, setCurrency } = useDashboardCurrencyFilter();

  return (
    <MCustomSelect
      maxW="9.125rem" // 146px
      useMainInputAsSearchInput
      itemTitle="code"
      itemValue="code"
      displayAvatar
      endpoint={`/api/currencies`}
      loadAll
      additionalSearchParams={{ sort: 'code' }}
      popOverProps={{
        positioning: {
          sameWidth: false,
          // Anchor the menu to the trigger's right edge so it grows leftward.
          // Without this, dashboards on the page's right side push the menu
          // off-screen when content (e.g. currency name) is wider than the
          // 146px trigger.
          placement: 'bottom-end',
        },
      }}
      popOverContentProps={{
        minW: '13rem',
      }}
      renderItemContent={({ item, isSelected }) => {
        return (
          <MFlex alignItems="center">
            <MText fontWeight="700" mr="2">
              {item.code}
            </MText>
            <MText fontWeight="normal">
              {ALL_CURRENCIES[item.code as CurrencyCodes].name}
            </MText>
          </MFlex>
        );
      }}
      value={currency}
      onChange={(val: any) => {
        setCurrency(val);
      }}
    />
  );
};
